export const SIDEBAR_FLOAT_WIDTH = 991;
export const SCROLL_OFFSET = 200;
